module.exports = __webpack_public_path__ + "img/tutorial_img_4.054a146c.svg";